import BackendAPI from '../api/BackendAPI.js';
import config from './../config.js';
import { AuthenticationService } from './authentication-service';
import { OffersService } from './offers-service';
import qs from 'query-string';
import { hasOptedOutOfTrackingCookie } from '../utils/metaTrackingUtils';
import { extractQueryParams } from '../ui/components/routing/helpers.js'; 

const versions = {
    version1: 'v1',
    version2: 'v2',
};

export class CoreAPI extends BackendAPI {
    constructor() {
        super();
        this.serverPath = config.coreApiUrl;
        this.authentication = new AuthenticationService();
        this.offers = new OffersService();
    }

    getVendorConfig() {
        const url = `${this.serverPath}${versions.version1}/vendor-config`;
        return this.request('GET', url);
    }

    apply(body) {
        const url = `${this.serverPath}${versions.version2}/apply`;
        return this.request('POST', url, body);
    }

    register(body) {
        const url = `${this.serverPath}${versions.version2}/register`;
        return this.request('POST', url, body);
    }

    registerLeads(body) {
        const url = `${this.serverPath}${versions.version2}/registerlead`;
        return this.request('POST', url, body);
    }

    leadComplete(body) {
        const url = `${this.serverPath}${versions.version2}/leadComplete`;
        return this.request('POST', url, body);
    }

    emailUpdate(body) {
        const url = `${this.serverPath}${versions.version2}/emailUpdate`;
        return this.request('POST', url, body);
    }

    fetchDisclosures(body) {
        const url = `${this.serverPath}${versions.version1}/disclosures`;
        return this.request('POST', url, body);
    }

    getServiceMode(serviceName) {
        const url = `${this.serverPath}${
            versions.version1
        }/getServiceMode/${serviceName}`;
        return this.request('GET', url);
    }

    fetchDenialReasons() {
        const url = `${this.serverPath}${versions.version2}/loans/adverseAction`;
        return this.request('GET', url);
    }

    pullCredit(loanId) {
        const url = `${this.serverPath}${versions.version1}/loans/${loanId}/pullCredit`;
        return this.request('PUT', url);
    }

    pullCreditUnfreeze() {
        const url = `${this.serverPath}${versions.version2}/loans/pullCreditUnfreeze`;
        return this.request('PUT', url  + extractQueryParams(window.location.hash,['id','iat']));
    }

    piiRetry({ form: body, queryParams={} }) {
        const stringified = qs.stringify(queryParams);
        const queryString = stringified ? '?' + stringified : '';
        const url = `${this.serverPath}${versions.version2}/loans/piiRetry${queryString}`;
        return this.request('PUT', url, body);
    }

    generateVariants(body) {
        return this.request('POST', `${this.serverPath}${versions.version2}/rlab/variants`, body);
    }

    generateVariantsAuthenticated(body, loanId) {
        return this.request('POST', `${this.serverPath}${versions.version1}/loans/${loanId}/rlabVariants`, body);
    }

    createRocketAccount(body) {
        return this.request('POST', `${this.serverPath}${versions.version2}/rocketAccount/create`, body);
    }

    pollWithAppRouterToken(token=null) {
        return this.request('GET', `${this.serverPath}${versions.version2}/routed-application?token=${token}`);
    }

    getClientData() {
        const url = `${this.serverPath}${versions.version1}/clients/client`;
        return this.request('GET', url);
    }

    leadCompleteAuthenticated(body, loanId) {
        const url = `${this.serverPath}${versions.version1}/loans/${loanId}/leadComplete`;
        return this.request('POST', url, body);
    }

    sendEvent(eventName, eventId) {
        if (hasOptedOutOfTrackingCookie()) {
            return Promise.resolve({ data: { message: 'sendEvent skipped' } });
        }
        const url = `${this.serverPath}${versions.version2}/loans/event/${eventName}`;
        return this.request('POST', url, { eventId });
    }
}
